import { ThankYouEmail } from './ThankYouEmail';
export default ThankYouEmail;
